import React from 'react';

export const TimerCheckmark = () => (
  <g
    id="g151"
    transform="matrix(49.088678,0,0,49.088678,-2.9525471e-6,-2.9525472e-6)"
    strokeWidth="0.0203713"
  >
    <path
      fill="#c2ccd8"
      strokeWidth="0.0203713"
      d="m 19.05,14.65 1.4,1.4 -3.95,3.95 -2.95,-2.95 1.4,-1.4 1.55,1.55 z M 17,12 A 5.0005,5.0005 0 1 0 17.001,22.001 5.0005,5.0005 0 0 0 17,12 Z M 9,4 V 9.586 L 5.293,13.293 6.707,14.707 11,10.414 V 4 Z M 10,0 C 4.486,0 0,4.486 0,10 c 0,5.514 4.486,10 10,10 0.225,0 0.445,-0.018 0.666,-0.033 a 6.94,6.94 0 0 1 -0.588,-1.97 C 10.051,17.997 10.027,18 10,18 5.589,18 2,14.411 2,10 2,5.589 5.589,2 10,2 c 4.411,0 8,3.589 8,8 0,0.027 -0.004,0.051 -0.004,0.078 a 6.9,6.9 0 0 1 1.97,0.59 C 19.982,10.446 20,10.225 20,10 20,4.486 15.514,0 10,0 Z"
    />
  </g>
);
